"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Actions = exports.getMissingMatches = exports.setBanners = exports.setCmsBanners = exports.getAvailableBannerZones = exports.getBannersData = void 0;
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var core_1 = __importStar(require("@gin-betting/core"));
var constants_1 = require("./constants");
var selectors_1 = require("./selectors");
var _a = core_1.default.entities, normalizeEntity = _a.normalizeEntity, _b = _a.actions, getEventMatchOfTheDay = _b.getEventMatchOfTheDay, getEventLiveOfTheDay = _b.getEventLiveOfTheDay, storeNormalizedEntities = _b.storeNormalizedEntities, makeGetMissingMatches = _b.makeGetMissingMatches, _c = core_1.default.utils, makeAction = _c.makeAction, getBettingOptions = _c.getBettingOptions;
var getBannersData = function (variables, args) {
    if (args === void 0) { args = {}; }
    return ({
        type: constants_1.GET_BANNERS_DATA_REQUEST,
        payload: {
            method: 'getBanners',
            variables: variables,
            args: __assign(__assign({}, args), { zoneId: variables.zoneId }),
        },
        meta: { isApiCall: true },
    });
};
exports.getBannersData = getBannersData;
var getAvailableBannerZones = function (attributes) {
    return {
        type: constants_1.GET_BANNER_ZONES_REQUEST,
        payload: {
            method: 'getBannerZones',
            variables: attributes
                ? {
                    attributes: {
                        pageTypes: [attributes.pageType],
                        platforms: [attributes.platform],
                    },
                }
                : undefined,
        },
        meta: { isApiCall: true },
    };
};
exports.getAvailableBannerZones = getAvailableBannerZones;
var setCmsBanners = function (payload) {
    return makeAction(constants_1.GET_CMS_BANNERS_SUCCESS, payload);
};
exports.setCmsBanners = setCmsBanners;
var setBanners = function (data, zoneId, getBannersByIdsCallback) { return function (dispatch, getState) {
    var matches = [];
    var cmsBannerIdsToFetch = [];
    var selectedSportIds = getBettingOptions().selectedSportIds;
    data.banners.forEach(function (banner) {
        switch (banner.type) {
            case core_1.API.BannerType.betting_live_of_the_day: {
                dispatch(getEventLiveOfTheDay({ sportIds: selectedSportIds }, { zoneId: zoneId }));
                break;
            }
            case core_1.API.BannerType.betting_match_of_the_day: {
                dispatch(getEventMatchOfTheDay({ sportIds: selectedSportIds }, { zoneId: zoneId }));
                break;
            }
            case core_1.API.BannerType.betting_sport_event: {
                if (banner.sportevent) {
                    matches.push(banner.sportevent);
                }
                break;
            }
            case core_1.API.BannerType.betting_tournament: {
                var tournament = banner.tournament;
                var normalizeTournament = normalizeEntity({
                    tournaments: __assign({}, tournament),
                });
                dispatch(storeNormalizedEntities(normalizeTournament, {
                    isTopMarkets: false,
                }));
                break;
            }
            case core_1.API.BannerType.cms_banner: {
                var storedCmsBanners = selectors_1.selectCmsBanners(getState());
                if (storedCmsBanners.some(function (_a) {
                    var id = _a.id;
                    return id === banner.id;
                })) {
                    break;
                }
                cmsBannerIdsToFetch.push(banner.id);
                break;
            }
            default:
        }
    });
    if (matches.length > 0) {
        var normalized = normalizeEntity({
            matches: matches,
        });
        dispatch(storeNormalizedEntities(normalized, {
            isTopMarkets: true,
        }));
    }
    getBannersByIdsCallback(cmsBannerIdsToFetch)
        .then(function (banners) {
        dispatch(exports.setCmsBanners({ banners: banners }));
    })
        .catch(function (error) {
        throw error;
    });
}; };
exports.setBanners = setBanners;
exports.getMissingMatches = makeGetMissingMatches({
    type: constants_1.GET_MISSING_MATCHES_REQUEST,
    withMarketsCount: true,
});
exports.Actions = {
    getBannersData: exports.getBannersData,
    setCmsBanners: exports.setCmsBanners,
};
//# sourceMappingURL=actions.js.map